export function mascararPeriodoAquisitivo(valor: string) {
  const digitos = (valor || '').replace(/\D/g, '').slice(0, 8);
  if (digitos.length <= 4) {
    return digitos;
  }
  return `${digitos.slice(0, 4)}-${digitos.slice(4)}`;
}

export function periodoAquisitivoValido(valor?: string) {
  return /^\d{4}-\d{4}$/.test(valor || '');
}

export function calcularDiasPortaria(inicio?: string, fim?: string) {
  if (!inicio || !fim) {
    return 0;
  }
  const dataInicio = new Date(`${inicio}T00:00:00`);
  const dataFim = new Date(`${fim}T00:00:00`);
  if (Number.isNaN(dataInicio.getTime()) || Number.isNaN(dataFim.getTime()) || dataFim < dataInicio) {
    return 0;
  }
  return Math.floor((dataFim.getTime() - dataInicio.getTime()) / 86400000) + 1;
}

export function nomeArquivoPortaria(numero?: number, ano?: number) {
  return numero && ano ? `portaria-ferias-${numero}-${ano}.doc` : 'portaria-ferias.doc';
}
